module.exports = __webpack_public_path__ + "img/social-aggression.cd04ec92.svg";